import { IconCirclePlus } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import IconButton from '../../../components/Buttons/IconButton'
import TableComponent from '../../../components/DataTable/TableComponent'
import AddPromotionUrlModal from './AddPromotionUrlModal'
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller'
import { getApi } from '../../../api/call.api'
import { urlApi } from '../../../api/url.api'
import EditPredefineUrlModal from './EditPredefineUrlModal'

const PredefinedPromotionUrlsSection = () => {

    const [data, setData] = useState([])

    const columns = [{ name: "Sl. No", center: "true", width: '40px', selector: (row) => row?._id, cell: (row, index) => (index + 1) },
    {
        name: "Name", center: "true", selector: (row) => row?.name, grow: 0.2, cell: (row) => (
            <p className="mb-0">{row?.name || "--"}</p>
        )
    }, {
        name: "URL", center: "true", selector: (row) => row?.promotionUrl, cell: (row) => (
            <p className="mb-0">{row?.promotionUrl ?? "--"}</p>
        )
    }, {
        name: "Action", center: "true", selector: (row) => row?.action, grow: 0.1, cell: (row) => (
            <EditPredefineUrlModal buttonComponent={<button className="mb-0 !border !px-2 !py-1 rounded" >Edit</button>} urlData={row} callback={() => getList()} />)
    }]

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.getPredefinedPromotionUrlList);
        loadingHide();
        if (resp.responseCode === 200) {
            setData(resp.data);
        } else {
            setData([]);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    return (
        <>
            <div className='mb-3 flex items-center justify-between'>
                <div>
                    <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Predefined Promotion URLs</p>
                    <p className='text-xs italic mb-0 text-gray-500 px-2'>*You can add maximum of 10 URLs .</p>
                </div>
                {data?.length < 10 && <AddPromotionUrlModal buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Add URL"} />} callback={() => getList()} />}
            </div>

            <TableComponent
                columns={columns}
                data={data}
                totalRows={data?.length}
                isHeader={true}
                isPagination={false}
                paginationPerPage={10}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </>
    )
}

export default PredefinedPromotionUrlsSection